import * as yup from "yup";

export const channelValidateSchema = yup.object().shape({
  name: yup.string().required("This field is required").trim(),
  email: yup.string().required("This field is required").trim().email("Please enter a valid email address"),
  master_application_key: yup.string().trim(),
});
